import React from "react"
import {
  Box,
  Button,
  Icons,
  Typography,
  Radio,
  withStyles,
} from "@ridecell/web-components-material"
import { FormattedMessage, injectIntl } from "react-intl"

import messages from "./messages"
import styles from "./styles"

const disabledColor = "rgba(0, 0, 0, 0.26)"
const excludeLastFourFor = ["Google Pay", "Apple Pay"]

const showLastFourDigits = (cardType) => !excludeLastFourFor.includes(cardType)

const PaymentMethods = ({
  cards,
  classes,
  deleteCard,
  intl: { formatMessage },
  markAsDefault,
  onAddCard,
}) => {
  return (
    <React.Fragment>
      {cards.length === 0 ? (
        <Box display="flex" justifyContent="center">
          <Button
            color="secondary"
            onClick={onAddCard}
            size="small"
            startIcon={<Icons.Add />}
            variant="outlined"
          >
            <FormattedMessage {...messages.addPaymentMethod} />
          </Button>
        </Box>
      ) : (
        <Box>
          {cards.map((card) => {
            return (
              <Box
                alignItems="center"
                display="flex"
                justifyContent="space-between"
                py={"8px"}
                px={"4px"}
              >
                <Box alignItems="center" display="flex" flexWrap="wrap">
                  <Typography
                    style={{ fontWeight: 600 }}
                    variant="body1"
                  >{`${card.card_type} `}</Typography>
                  {showLastFourDigits(card.card_type) && (
                    <React.Fragment>
                      <Box style={{ margin: "0 8px" }}>
                        <Typography variant="body1">
                          {formatMessage(messages.endingIn)}
                        </Typography>
                      </Box>
                      <Typography
                        style={{ fontWeight: 600 }}
                        variant="body1"
                      >{`${card.last_four_digits}`}</Typography>
                    </React.Fragment>
                  )}
                </Box>
                <Box alignItems="center" display="flex">
                  <Box className={classes.defaultBox} mr={"8px"}>
                    {card.in_use && (
                      <div className={classes.defaultTitle}>
                        {formatMessage(messages.default)}
                      </div>
                    )}
                    <Radio
                      checked={card.in_use}
                      color="secondary"
                      name="default"
                      onChange={() => markAsDefault(card.card_id)}
                    />
                  </Box>
                  <Button
                    color="primary"
                    disabled={card.in_use}
                    onClick={() => deleteCard(card.card_id)}
                    size="small"
                    startIcon={
                      <Icons.DeleteOutline
                        disabled
                        style={{
                          color: !card.in_use ? "red" : disabledColor,
                        }}
                      />
                    }
                    variant="outlined"
                  >
                    <FormattedMessage {...messages.deleteCard} />
                  </Button>
                </Box>
              </Box>
            )
          })}
          <Box display="flex" mt={"8px"}>
            <Button
              color="secondary"
              onClick={onAddCard}
              size="small"
              startIcon={<Icons.Add />}
              variant="text"
            >
              <FormattedMessage {...messages.addPaymentMethod} />
            </Button>
          </Box>
        </Box>
      )}
    </React.Fragment>
  )
}

export default withStyles(styles)(injectIntl(PaymentMethods))
